import { Component, inject } from '@angular/core';
import { AuthService } from '../app/services/auth.service';
import { environment } from 'src/environments/environment';
import { InfoCollectionService } from './services/info-collection.service';
import { ManagementDataService } from './services/management-data.service';
import { ModulesServiceService } from './services/modules-service.service';
import { UmamiService } from './services/umami.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  umamiServ = inject(UmamiService);

  public appPages = [];
  public adminPages = [];
  public miscPages = [];
  
  public userLoggedIn:boolean = false;
  public currentUser:any = {}
  activeRoles: any;

  constructor(private auth:AuthService, private collectServ:InfoCollectionService, private dataServ: ManagementDataService ) {
    this.umamiServ.loadUmami();
    this.collectUserInfo();

    if (this.auth.userInfo() == null) {
      this.auth.userInfo.set(JSON.parse(localStorage.getItem('user_role') || '{}'));
    }

    this.userLoggedIn = this.auth.isUserLoggedIn();
    if (this.userLoggedIn) {
      this.currentUser = this.auth.whoami();
    }

    console.log(location.href.split('/')[location.href.split('/').length -1] == '');
    if( this.userLoggedIn == true){
      if (!window.location.href.includes('login')) {
        this.auth.getUserRole().subscribe(
          {
            next: (user_detail:any) => {
              //console.log(user_detail);
              this.auth.userInfo.set(user_detail.permission);
              localStorage.setItem('user_role', JSON.stringify(user_detail.permission));
              this.verificarModulos();
              return user_detail.permission;
            },
            error: (error) => {
              return error;
            } 
          }
        );

        console.log(this.auth.userInfo());
      }
    }
  }

  logout(){
    this.auth.logout();
    this.userLoggedIn = this.auth.isUserLoggedIn();
  }

  moduleServ = inject(ModulesServiceService);
  verificarModulos(){

    this.appPages.push(
      { title: 'Menú principal', url: '/menu-principal', icon: 'home' },
    )



    this.dataServ.request('segment','').subscribe((env_data:any)=>{
      console.log(env_data);
      this.activeRoles = this.auth.userInfo().modules;
      console.log(this.activeRoles);
      
      let available_modules = env_data.data.attributes;
      this.moduleServ.setActiveModules(available_modules);

      if (available_modules.appointments && this.activeRoles.appointments.read) {
        this.appPages.push(
          { title: 'Citas', url: '/citas', icon: 'calendar-number' },
        )
      }
      if (available_modules.customers && this.activeRoles.customers.read) {
        this.appPages.push(
          { title: 'Clientes', url: '/clientes', icon: 'people' },
        )
      }
      if (available_modules.insurance_jobs && this.activeRoles.insurance_jobs.read) {
        this.appPages.push(
          { title: 'Trabajos aseguradoras', url: '/insurance-jobs', icon: 'file-tray-stacked' },
        )
      }
      if (available_modules.inventory && this.activeRoles.inventory.read) {
        this.appPages.push(
          { title: 'Inventario', url: '/inventarios', icon: 'albums' },
        )
      }
      if (available_modules.quotes && this.activeRoles.quotes.read) {
        this.appPages.push(
          { title: 'Cotizaciones', url: '/cotizaciones', icon: 'document-text' },
        )
      }
      if (available_modules.receptions && this.activeRoles.receptions.read) {
        this.appPages.push(
          { title: 'Recepciones', url: '/recepciones', icon: 'receipt' },
        ) 
      }
      if (available_modules.sales && this.activeRoles.sales.read) {
        this.appPages.push(
          { title: 'Ventas', url: '/pagos', icon: 'wallet' },
        )
      }
      if (available_modules.vehicules && this.activeRoles.vehicules.read) {
        this.appPages.push(
          { title: 'Vehículos', url: '/control-vehiculos', icon: 'car-sport' },
        )
      }
      if (available_modules.workorders && this.activeRoles.workorders.read) {
        this.appPages.push(
          { title: 'Ordenes de trabajo', url: '/workorders', icon: 'construct' },
        )
      }

      if(this.activeRoles.isAdmin){
        this.adminPages.push(
          { title: 'Menú administrativo', url: '/admin/menu', icon: 'cube' },
          //{ title: 'Usuarios', url: '/admin/users', icon: 'body' },
          //{ title: 'Roles de usuario', url: '/admin/user-roles', icon: 'pricetags' },
        );
      }

    },(error)=>{
      console.log(error);
    });

  }

  collectUserInfo(){
    this.collectServ.collectEnv({info:'no info'}).then((env_info:any)=>{
      console.log(env_info);
    })
  }


}
